<template>
    <div>
        <b-modal v-if="!modalHtml" id="premium-modal" :visible="$store.getters.getPremiumModalState" size="lg" class="webapp-hide-disabled">
            <template #modal-header>
                <h1 class="premium-modal-title" v-translate>Gekko premium</h1>
                <GekkoButton 
                    @click="closeModal()"
                    icon="fa-solid fa-xmark"
                    variant="link"
                    size="lg"
                    class="close text-unassigned"
                />
            </template>
            <template #default>
                <div class="features">
                    <ul>
                        <li v-b-toggle.collapse-1><a href="javascript:;"><font-awesome-icon icon="fa-solid fa-plus" /> <span v-translate>Multiple company profiles</span></a>
                            <b-collapse id="collapse-1">
                                <div class="feature-text" v-translate>Manage your companies with a single account</div>
                            </b-collapse>
                        </li>
                        <li v-b-toggle.collapse-2><a href="javascript:;"><font-awesome-icon icon="fa-solid fa-plus" /> <span v-translate>Team members</span></a>
                            <b-collapse id="collapse-2">
                                <div class="feature-text" v-translate>Connect team members to your company profile.
                                </div>
                            </b-collapse>
                        </li>
                        <li v-b-toggle.collapse-3><a href="javascript:;"><font-awesome-icon icon="fa-solid fa-plus" /> <span v-translate>Advanced invoicing</span></a>
                            <b-collapse id="collapse-3">
                                <div class="feature-text" v-translate>
                                    Custom design, schedule invoices, foreign valuta, unlimited quotations
                                </div>
                            </b-collapse>
                        </li>
                        <li v-b-toggle.collapse-4><a href="javascript:;"><font-awesome-icon icon="fa-solid fa-plus" /> <span v-translate>Custom data management</span></a>
                            <b-collapse id="collapse-4">
                                <div class="feature-text" v-translate>
                                    Create custom cost types, forward receipts from your e-mail etc.
                                </div>
                            </b-collapse>
                        </li>
                        <li v-b-toggle.collapse-5><a href="javascript:;"><font-awesome-icon icon="fa-solid fa-plus" /> <span v-translate>Reporting</span></a>
                            <b-collapse id="collapse-5">
                                <div class="feature-text" v-translate>
                                    Generate your vat report, products report, revenue reports per customer etc.
                                </div>
                            </b-collapse>
                        </li>
                    </ul>
                </div>
                <h4 class="text-center price"><span v-translate>Only</span> <span class="premium-modal-price">10€</span>
                    <span v-translate>/ month</span></h4>
            </template>
            <template #modal-footer>
                <GekkoButton 
                    data-analytics-click="Subscription modal v3: pricing"
                    :href="Urls['pages']('pricing')"
                    :text="$gettext('See all features')"
                    target="_blank"
                    variant="outline-primary"
                    class="mr-auto"
                />

                <GekkoButton 
                    data-analytics-click="Subscription modal v3: upgrade"
                    :href="Urls['subscriptions:manage']()"
                    :text="$gettext('Upgrade premium')"
                    icon="fa-solid fa-star"
                    class="premium-button"
                />
            </template>
        </b-modal>
        <b-modal v-if="modalHtml" id="premium-modal" v-model="modalState" size="lg" class="webapp-hide-disabled"
                 @close="closeModal()" footer-class="d-none" header-class="d-none">
            <span v-if="modalHtml" v-html="modalHtml" id="premium-message-box"></span>
        </b-modal>
    </div>
</template>
<script>
    import PremiumService from "@/store/services/premium.service.js";
    import GekkoButton from "@/components/GekkoButton";

    export default {
        name: "PremiumModal",
        components: { GekkoButton },
        data() {
            return {
                modalHtml: null,
            }
        },
        watch: {
            "$store.state.showPremiumModal": {
                handler: function (newVal) {
                    if (newVal) {
                        var vm = this;
                        if (this.$store.getters.getIsPremiumModalCode) {
                            PremiumService.list({code: this.$store.getters.getIsPremiumModalCode}).then(function (response) {
                                vm.modalHtml = response.data[0].content;
                            }).catch(function () {
                                vm.modalHtml = null;
                            })
                        }
                    } else {
                        this.modalHtml = null;
                    }
                },
                deep: true
            }
        },
        methods: {
            closeModal() {
                this.$store.commit('togglePremiumModal', null);
            }
        },
        computed: {
            modalState: {
                get() {
                    return this.$store.getters.getPremiumModalState;
                },
                set(newValue) {
                    this.$store.commit('togglePremiumModal', newValue);
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    #premium-modal___BV_modal_outer_ {
        z-index: 9001 !important;
    }
    .premium-modal-title {
        color: $colorBrand;
        margin-top: 0px;
        margin-bottom: 2px;
    }

    .features {
        margin-bottom: 18px;
        margin-left: 4px;
    }

    .features ul li {
        display: block;
        margin-bottom: 10px;
    }

    .features ul li a {
        color: $colorBrand;
    }

    .feature-text {
        margin-left: 18px;
        color: #797979;
        font-size: 16px;
    }

    .premium-modal-price {
        color: $colorBrand;
        font-family: DINNextLTPro-Medium, sans-serif;
    }
    .price {
        font-size: 20px;
        font-family: DINNextLTPro-Regular, sans-serif;
        color: $colorBrand;
    }
</style>